var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BModal',{attrs:{"width":1253,"active":_vm.show,"trap-focus":"","destroy-on-hide":false,"aria-role":"dialog","aria-modal":"","can-cancel":['outside', 'escape']},on:{"close":function($event){return _vm.$emit('close')}}},[_c('ContentModal',{attrs:{"show":_vm.show},on:{"close":function($event){return _vm.$emit('close')}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }